module.exports = __webpack_public_path__ + "img/23.db351771.jpeg";